module.exports = __webpack_public_path__ + "static/media/139-venezuela.ba33ae96.svg";